function addClass(element, className) {
  if (element && className) element.classList.add(className);
}

function removeClass(element, className) {
  if (element && className) element.classList.remove(className);
}

function isModifierActive(event, modifier) {
  return !!(event && typeof event.getModifierState === 'function' && event.getModifierState(modifier) === true);
}

function enablePasswordInput(input) {
  input.removeAttribute('readonly');
}

function armPasswordInput(input) {
  input.setAttribute('readonly', 'readonly');
  var unlock = function (event) {
    if (!event || event.isTrusted !== false) enablePasswordInput(input);
  };

  input.addEventListener('focusin', unlock);
  input.addEventListener('pointerdown', unlock);
  input.addEventListener('keydown', unlock);
}

function updatePasswordVisibility(event, show, passwordInput, iconShow) {
  if (show && passwordInput.interacted) {
    if (event) event.preventDefault();
    if (passwordInput.type !== 'text') {
      passwordInput.type = 'text';
      addClass(iconShow, 'login__password__icons__show--active');
    }
    return;
  }

  if (passwordInput.type !== 'password') passwordInput.type = 'password';
  removeClass(iconShow, 'login__password__icons__show--active');
}

function updatePasswordStateText(passwordInput, iconShift, iconCapslock, stateText) {
  if (!stateText) return;

  var shiftVisible = !!(iconShift && !iconShift.classList.contains('login__password__icon--hidden'));
  var capsVisible = !!(iconCapslock && !iconCapslock.classList.contains('login__password__icon--hidden'));
  var htmlPrompt = '<span data-kind="prompt">Enter Password Above</span>';
  var htmlCaps = '<span data-kind="caps-on">Caps Lock On</span>';
  var htmlShift = '<span data-kind="shift-on">Shift On</span>';

  if (!iconShift && !iconCapslock) stateText.innerHTML = htmlPrompt;
  else if (capsVisible && shiftVisible) stateText.innerHTML = htmlCaps + '<span class="login__password__state__separator">, </span>' + htmlShift;
  else if (capsVisible) stateText.innerHTML = htmlCaps;
  else if (shiftVisible) stateText.innerHTML = htmlShift;
  else stateText.innerHTML = htmlPrompt;
}

function updatePasswordInput(event, isUserInvoked, isKeyEvent, passwordContainer, passwordInput, iconShift, iconCapslock, iconShow, stateText) {
  var iconCluster = passwordContainer ? passwordContainer.querySelector('.login__password__icons') : null;
  var clusterWidth = 0;
  var shouldShowShift = iconShift && isUserInvoked && isKeyEvent && isModifierActive(event, 'Shift');
  var shouldShowCaps = iconCapslock && isUserInvoked && isKeyEvent && isModifierActive(event, 'CapsLock');

  if (iconShift) {
    if (shouldShowShift) {
      removeClass(iconShift, 'login__password__icon--hidden');
    } else addClass(iconShift, 'login__password__icon--hidden');
  }

  if (iconCapslock) {
    if (shouldShowCaps) {
      removeClass(iconCapslock, 'login__password__icon--hidden');
    } else addClass(iconCapslock, 'login__password__icon--hidden');
  }

  if (!isKeyEvent) updatePasswordVisibility(false, false, passwordInput, iconShow);

  if (passwordInput.value && passwordInput.interacted && isUserInvoked) {
    removeClass(iconShow, 'login__password__icon--hidden');
  } else if (isUserInvoked) {
    addClass(iconShow, 'login__password__icon--hidden');
  }

  if (iconCluster) clusterWidth = iconCluster.getBoundingClientRect().width;
  passwordContainer.style.paddingRight = (clusterWidth ? Math.ceil(clusterWidth) + 8 : 0) + 'px';
  updatePasswordStateText(passwordInput, iconShift, iconCapslock, stateText);

  if (passwordInput === document.activeElement) {
    passwordInput.setSelectionRange(passwordInput.selectionStart, passwordInput.selectionEnd);
  }
}

function setupPasswordInterface(passwordContainer) {
  var passwordInput = passwordContainer.getElementsByTagName('input')[0];
  if (!passwordInput || passwordInput.type !== 'password') return;

  armPasswordInput(passwordInput);

  var isIOS = (/iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream;
  var iconShift = isIOS ? false : passwordContainer.getElementsByClassName('login__password__icons__shift')[0];
  var iconCapslock = isIOS ? false : passwordContainer.getElementsByClassName('login__password__icons__capslock')[0];
  var iconShow = passwordContainer.getElementsByClassName('login__password__icons__show')[0];
  var stateRow = passwordContainer.parentElement;
  var stateText = stateRow ? stateRow.getElementsByClassName('login__password__state')[0] : null;
  var showButton = iconShow ? iconShow.querySelector('button') : null;

  passwordInput.addEventListener('focusin', function () {
    if (!this.interacted) {
      // Simulates clearing potentially injected/autofilled value on first real interaction.
      passwordInput.value = '';
      this.interacted = true;
    }
  });

  passwordInput.addEventListener('focusout', function (event) {
    updatePasswordVisibility(event, false, passwordInput, iconShow);
    updatePasswordInput(event, true, false, passwordContainer, passwordInput, iconShift, iconCapslock, iconShow, stateText);
  });
  passwordInput.addEventListener('mousedown', function (event) {
    updatePasswordInput(event, true, true, passwordContainer, passwordInput, iconShift, iconCapslock, iconShow, stateText);
  });
  passwordInput.addEventListener('keydown', function (event) {
    updatePasswordInput(event, true, true, passwordContainer, passwordInput, iconShift, iconCapslock, iconShow, stateText);
  });
  passwordInput.addEventListener('keyup', function (event) {
    updatePasswordInput(event, true, true, passwordContainer, passwordInput, iconShift, iconCapslock, iconShow, stateText);
  });

  if (showButton) {
    showButton.addEventListener('mousedown', function (event) {
      updatePasswordVisibility(event, true, passwordInput, iconShow);
      updatePasswordStateText(passwordInput, iconShift, iconCapslock, stateText);
    });
    showButton.addEventListener('mouseup', function (event) {
      updatePasswordVisibility(event, false, passwordInput, iconShow);
      updatePasswordStateText(passwordInput, iconShift, iconCapslock, stateText);
    });
    showButton.addEventListener('mouseleave', function (event) {
      updatePasswordVisibility(event, false, passwordInput, iconShow);
      updatePasswordStateText(passwordInput, iconShift, iconCapslock, stateText);
    });
    showButton.addEventListener('touchstart', function (event) {
      updatePasswordVisibility(event, true, passwordInput, iconShow);
      updatePasswordStateText(passwordInput, iconShift, iconCapslock, stateText);
    });
    showButton.addEventListener('touchend', function (event) {
      updatePasswordVisibility(event, false, passwordInput, iconShow);
      updatePasswordStateText(passwordInput, iconShift, iconCapslock, stateText);
    });
    showButton.addEventListener('touchcancel', function (event) {
      updatePasswordVisibility(event, false, passwordInput, iconShow);
      updatePasswordStateText(passwordInput, iconShift, iconCapslock, stateText);
    });
  }

  updatePasswordInput(false, false, false, passwordContainer, passwordInput, iconShift, iconCapslock, iconShow, stateText);
}

function setupPasswordInterfaces(className) {
  var passwordContainers = document.getElementsByClassName(className);
  for (var i = 0; i < passwordContainers.length; i++) setupPasswordInterface(passwordContainers[i]);
}

function wirePasswordLabels() {
  var passwordRows = document.querySelectorAll('.login__input.login__password');
  for (var i = 0; i < passwordRows.length; i++) {
    var row = passwordRows[i];
    var label = row.querySelector('label');
    var input = row.querySelector('input[type="password"]');

    if (!label || !input) continue;

    if (!input.id) input.id = 'password-field-' + (i + 1);
    if (label.htmlFor !== input.id) label.htmlFor = input.id;

    label.addEventListener('click', function (event) {
      var targetLabel = event.currentTarget;
      var targetInput = targetLabel && targetLabel.htmlFor ? document.getElementById(targetLabel.htmlFor) : null;
      if (!targetInput) return;

      enablePasswordInput(targetInput);
      targetInput.focus();
    });
  }
}

function clearPasswordValues() {
  var fields = document.querySelectorAll('.password__feedback');
  for (var i = 0; i < fields.length; i++) fields[i].value = '';
}

window.addEventListener('beforeunload', clearPasswordValues);
window.addEventListener('pagehide', clearPasswordValues);

wirePasswordLabels();
setupPasswordInterfaces('login__password__icons-container');
